import React from 'react'
import ContentLoader from 'react-content-loader'
import {Card} from "reactstrap";

const HomePageAgentListLoaderCard = props => (

   <Card className="list mt-3 w-75 mx-auto">
       <ContentLoader
           width="100%"
           height={250}
           viewBox="0 0 1000 200"
           backgroundColor="#f3f3f3"
           foregroundColor="#dbdbdb"
           {...props}
       >
           <rect x="100" y="9.93" rx="5" ry="5" width="300" height="150" />
           <rect x="450" y="9.67" rx="0" ry="0" width="450" height="12.12" />
           <rect x="450" y="40" rx="0" ry="0" width="100" height="12" />
           <rect x="450" y="70" rx="0" ry="0" width="400" height="12.12" />
           <rect x="450" y="100" rx="0" ry="0" width="89" height="12" />

       </ContentLoader>
   </Card>
);

export default HomePageAgentListLoaderCard